import { render, staticRenderFns } from "./tripartiteServiceItem.vue?vue&type=template&id=50df3db2&scoped=true&"
import script from "./tripartiteServiceItem.vue?vue&type=script&lang=ts&"
export * from "./tripartiteServiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./tripartiteServiceItem.vue?vue&type=style&index=0&id=50df3db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df3db2",
  null
  
)

export default component.exports